import React, { useState, useEffect } from "react";
import "./Quests.css";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { useAuth } from "../../../context/LoginContext/AuthContext";
import TaskCompletionStatusPieChart from "./Charts/TaskCompletionStatusPieChart";
import BackButton from "../Goback/GoBack";
import QuestCompletionStatusPieChart from "./Charts/QuestChart.jsx/QuestChart";

export const ParentQuests = () => {
  const [kidDetail, setKidDetail] = useState([]);
  const { kidId, kidName } = useParams(); // Get studentId from URL
  const { user ,fetchWithAuth} = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL;
  
  useEffect(() => {
    const fetchTrophies = async () => {
      if (!user || !user.token) {
        return;
      }
      try {
        const response = await fetchWithAuth(`${apiUrl}/parent/kid/progress/${kidId}`, {
          method: "GET",
        });

        if (!response.ok) {
          throw new Error("Failed to fetch trophies");
        }

        const data = await response.json();
        setKidDetail(data.data);
      } catch (err) {
      } finally {
      }
    };

    fetchTrophies();
  }, [user, kidId, apiUrl,fetchWithAuth]); // Add studentId to dependency array
  const navigate = useNavigate();
  return (
    <div className="dashboardBody">
      <div className="container-fluid p-0">
        <div className="p-0" id="mainContent">
          <div className="teacher-bodycontent mb-4">
            <section>
              <div className="container-fluid">
                <div className="row mb-4">
                  <div className="col-md-12">
                    <BackButton />
                  </div>
                  <div className="col-md-12 justify-content-center align-self-center">
                    <p className="tchrdashboard-cmntitl mb-0">
                      Quest Peformance
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <div className="row">
                      <div className="col-md-4 col-sm-6 mb-4">
                      <Link to={`/parent/quests/${kidId}/${kidName}/quest/all`}>
                        <div className="yuvadashboard-card">
                          <div className="row">
                            <div className="col-md-12 col-sm-12 col-12">
                              <p className="TchrQuestCardTitl mb-2">Total</p>
                              <p className="yuvadashboard-cardtxt mb-0">
                                {kidDetail.totalQuests}{" "}
                                <span className="TchrQuestCard-Para">
                                  Quests & Festivals
                                </span>
                              </p>
                            </div>
                          </div>
                          </div>
                          </Link>
                      </div>

                      <div className="col-md-4 col-sm-6 mb-4">
                        <Link to={`/parent/quests/${kidId}/${kidName}/quest/completed`}>
                        <div className="yuvadashboard-card">
                          <div className="row">
                            <div className="col-md-12 col-sm-12 col-12">
                              <p className="TchrQuestCardTitl mb-2">
                                Completed
                              </p>
                              <p className="yuvadashboard-cardtxt mb-0">
                                {kidDetail.completedQuests}{" "}
                                <span className="TchrQuestCard-Para">
                                  Quests & Festivals
                                </span>
                              </p>
                            </div>
                          </div>
                          </div>
                          </Link>
                      </div>

                      <div className="col-md-4 col-sm-6 mb-4">
                      <Link to={`/parent/quests/${kidId}/${kidName}/quest/pending`}>

                        <div className="yuvadashboard-card">
                          <div className="row">
                            <div className="col-md-12 col-sm-12 col-12">
                              <p className="TchrQuestCardTitl mb-2">Pending</p>
                              <p className="yuvadashboard-cardtxt mb-0">
                                {kidDetail.pendingQuests}{" "}
                                <span className="TchrQuestCard-Para">
                                  Quests & Festivals
                                </span>
                              </p>
                            </div>
                          </div>
                          </div>
                          </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="table-responsive">
                      <table className="table table-hover tchrtabl-pdng">
                      <thead className="quest-tablehead">
                      <tr>
                            <th scope="col">Quest Name</th>
                            <th scope="col" className="text-center">
                              Watched Episodes
                            </th>
                            <th scope="col" className="text-center">
                              Trophies Earned
                            </th>
                            <th scope="col" className="text-center">
                              Download Certificate
                            </th>
                          </tr>
                        </thead>
                        <tbody className="tchrtablbody">
                          {kidDetail?.progress?.map((quest, index) => (
                            <tr key={index}>
                              <td>{quest.questName} </td>
                              <td className="text-center">
                                {quest.completedEpisodes}
                              </td>
                              <td
                                className="text-center "
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  navigate(
                                    `/parent/quests/${kidId}/viewTrophy`
                                  );
                                }}
                              >
                                {quest?.trophyEarned === 1 ? (
                                  <img src="https://d2lvj32mp5x83n.cloudfront.net/static/parentadmin/details/trophyIcon/trophyFilled.png" alt="" />
                                ) : (
                                  <img src="https://d2lvj32mp5x83n.cloudfront.net/static/parentadmin/details/trophyIcon/trophyBlank.png" alt="award"/>
                                )}
                              </td>
                              {
                                quest?.questType==="quest" && <td className="text-center">
                                <Link
                                  className="ParentDwnloadBtn"
                                  to={`/parent/quests/${kidId}/${kidName}/${quest?.questId}/viewCertificate`}
                                >
                                  <img src="https://d2lvj32mp5x83n.cloudfront.net/static/parentadmin/details/certificateIcon/certificate.png" alt="" /> View
                                  Certificate
                                </Link>
                              </td>
                              }
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12 graphcard_1">
                    <div className="taskbar-graphcard">
                      <div id="task_count_title">Quest Performance</div>
                      <div>
                        <QuestCompletionStatusPieChart
                          data={kidDetail?.graph_data?.quest_progress?.map(
                            (quest) => ({
                              name: quest.title,
                              value: Number(quest.progress),
                              color:
                                "#" +
                                Math.floor(Math.random() * 16777215)
                                  .toString(16)
                                  .padStart(6, "0"),
                            })
                          )}
                          type={"percent"}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 graphcard_1">
                    <div className="taskbar-graphcard">
                      <div id="task_count_title">Certificates Achievement</div>
                      <div id="donut_single"></div>
                      <div
                        id="task_count_title"
                        style={{ marginBottom: "50px" }}
                      >
                        <TaskCompletionStatusPieChart
                          data={[
                            {
                              name: "Completed",
                              value: Number(
                                kidDetail?.graph_data?.completedCertificate
                              ),
                              color: "#73CEF4",
                            },
                            {
                              name: "Incomplete",
                              value:
                                Number(
                                  kidDetail?.graph_data?.totalCertificate
                                ) -
                                Number(
                                  kidDetail?.graph_data?.completedCertificate
                                ),
                              color: "#1C8AB8",
                            },
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 graphcard_1">
                    <div className="taskbar-graphcard">
                      <div id="task_count_title">Trophy Achievement</div>
                      <div id="donut_single"></div>
                      <div
                        id="task_count_title"
                        style={{ marginBottom: "50px" }}
                      >
                        <TaskCompletionStatusPieChart
                          data={[
                            {
                              name: "Completed",
                              value: Number(
                                kidDetail?.graph_data?.completedTrophy
                              ),
                              color: "#73CEF4",
                            },
                            {
                              name: "Incomplete",
                              value:
                                Number(kidDetail?.graph_data?.totalTrophy) -
                                Number(kidDetail?.graph_data?.completedTrophy),
                              color: "#1C8AB8",
                            },
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};
